import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Heading from "./Heading/Heading";
import Cards from "./Cards/Cards";

const Blog = () => {
  return (
    <>
      <Header />
      <Heading />
      <Cards />
      <Footer />
    </>
  );
};

export default Blog;
